export default "__VITE_ASSET__0634ef37__"